export const environment = {
  production: true,
  buildId: '3822965594023471',
  configFile: 'config.json',
};
